import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IInputValidationResponse } from './models/IInputValidationResponse.js';
import { ILabelledInputComponentProps, ILabelledInputConfiguration, ILabelledInputState } from './models/index.js';
import InputComponent from './styledComponents/InputComponent.js';
import LabelComponent from './styledComponents/LabelComponent.js';
import ValidationMessage from './styledComponents/ValidationMessage.js';
import Wrapper from './styledComponents/Wrapper.js';
import { LABELLED_INPUT_CATEGORY_KEY, LABELLED_INPUT_COMPONENT_KEY } from './LabelledInput.meta.js';

export class LabelledInput extends ComponentBase<
	ILabelledInputComponentProps,
	ILabelledInputState,
	ILabelledInputConfiguration
> {
	categoryKey = LABELLED_INPUT_CATEGORY_KEY;
	componentKey = LABELLED_INPUT_COMPONENT_KEY;

	constructor(props: ILabelledInputComponentProps) {
		super(props);

		makeObservable(this, {
			validation: observable,
			onChange: action,
		});
	}

	validation: IInputValidationResponse = {
		isValid: true,
	};

	onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { inputValidation, inputProps } = this.props;
		if (inputValidation) {
			const value = e.target.value;
			this.validation = inputValidation(value);
		}
		if (inputProps && inputProps.onChange) {
			inputProps.onChange(e);
		}
	};

	render() {
		const { className, labelProps, inputProps } = this.props;
		const { isValid = true, message: validationMessage = '' } = this.validation;

		return (
			<Wrapper className={className} data-is-valid={isValid}>
				<LabelComponent {...labelProps} />
				<InputComponent {...inputProps} onChange={this.onChange} />
				{!isValid && <ValidationMessage>{validationMessage}</ValidationMessage>}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(
	observer(LabelledInput),
	LABELLED_INPUT_CATEGORY_KEY,
	LABELLED_INPUT_COMPONENT_KEY,
);
